import React from 'react';

export interface Fact {
  label: string;
  value: React.ReactNode;
}

interface Props {
  facts: Fact[];
}

/** Two-column label/value grid used by every rail type. Facts with no value are skipped. */
export const FactsGrid: React.FC<Props> = ({ facts }) => (
  <dl className="rail-facts">
    {facts
      .filter((fact) => fact.value !== null && fact.value !== undefined && fact.value !== '')
      .map((fact) => (
        <div key={fact.label} className="rail-fact">
          <dt>{fact.label}</dt>
          <dd>{fact.value}</dd>
        </div>
      ))}
  </dl>
);

export const formatRailDate = (iso: string | null | undefined): string | null => {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export default FactsGrid;
